// AUTO-GENERATED by execution/gen_reference_tables.py — DO NOT EDIT.
// Source of truth: business/ishvaram/data/domain/astrology/*.yaml +
// engine constants.py (rules 23/24/29 — engine-verified, never hand-typed).
// Regenerate: uv run python execution/gen_reference_tables.py

export interface ReferenceDataset {
  readonly id: string;
  readonly caption: string;
  readonly columns: readonly string[];
  readonly rows: readonly (readonly string[])[];
}

export const REF_NUMBERS_EN: ReferenceDataset = {
  id: "numbers_en",
  caption: "The 9 numbers of Ank Jyotish — ruling planet & lucky signatures",
  columns: ["No.", "Ruling planet", "Lucky day", "Lucky colours", "Gemstone"],
  rows: [
    ["1", "Sun", "Sunday", "gold, orange, yellow", "Ruby (Manik)"],
    ["2", "Moon", "Monday", "white, cream, light green", "Pearl (Moti)"],
    ["3", "Jupiter", "Thursday", "yellow, violet, purple", "Yellow Sapphire (Pukhraj)"],
    ["4", "Rahu", "Saturday, Sunday", "blue, grey, khaki", "Hessonite (Gomed)"],
    ["5", "Mercury", "Wednesday", "green, light brown, grey", "Emerald (Panna)"],
    ["6", "Venus", "Friday", "white, pink, light blue", "Diamond (Heera)"],
    ["7", "Ketu", "Monday", "grey, white, light yellow", "Cat's Eye (Lehsunia)"],
    ["8", "Saturn", "Saturday", "dark blue, black, dark grey", "Blue Sapphire (Neelam)"],
    ["9", "Mars", "Tuesday", "red, scarlet, coral", "Red Coral (Moonga)"],
  ],
} as const;

export const REF_RASHIS_EN: ReferenceDataset = {
  id: "rashis_en",
  caption: "The 12 rashis — element, quality, ruling planet & symbol",
  columns: ["#", "Rashi", "Element", "Quality", "Ruler", "Symbol", "Lucky colour"],
  rows: [
    ["1", "Aries (मेष)", "Fire", "Cardinal", "Mars", "Ram", "Red"],
    ["2", "Taurus (वृषभ)", "Earth", "Fixed", "Venus", "Bull", "White"],
    ["3", "Gemini (मिथुन)", "Air", "Mutable", "Mercury", "Twins", "Green"],
    ["4", "Cancer (कर्क)", "Water", "Cardinal", "Moon", "Crab", "White"],
    ["5", "Leo (सिंह)", "Fire", "Fixed", "Sun", "Lion", "Gold"],
    ["6", "Virgo (कन्या)", "Earth", "Mutable", "Mercury", "Virgin", "Green"],
    ["7", "Libra (तुला)", "Air", "Cardinal", "Venus", "Scales", "White"],
    ["8", "Scorpio (वृश्चिक)", "Water", "Fixed", "Mars", "Scorpion", "Red"],
    ["9", "Sagittarius (धनु)", "Fire", "Mutable", "Jupiter", "Archer", "Yellow"],
    ["10", "Capricorn (मकर)", "Earth", "Cardinal", "Saturn", "Sea-Goat", "Blue"],
    ["11", "Aquarius (कुंभ)", "Air", "Fixed", "Saturn", "Water-Bearer", "Blue"],
    ["12", "Pisces (मीन)", "Water", "Mutable", "Jupiter", "Fish", "Yellow"],
  ],
} as const;

export const REF_RASHIS_HI: ReferenceDataset = {
  id: "rashis_hi",
  caption: "12 राशियाँ — तत्व, स्वामी ग्रह और चिह्न",
  columns: ["#", "राशि", "तत्व", "स्वामी ग्रह", "चिह्न"],
  rows: [
    ["1", "मेष", "Fire", "मंगल", "Ram"],
    ["2", "वृषभ", "Earth", "शुक्र", "Bull"],
    ["3", "मिथुन", "Air", "बुध", "Twins"],
    ["4", "कर्क", "Water", "चंद्र", "Crab"],
    ["5", "सिंह", "Fire", "सूर्य", "Lion"],
    ["6", "कन्या", "Earth", "बुध", "Virgin"],
    ["7", "तुला", "Air", "शुक्र", "Scales"],
    ["8", "वृश्चिक", "Water", "मंगल", "Scorpion"],
    ["9", "धनु", "Fire", "गुरु", "Archer"],
    ["10", "मकर", "Earth", "शनि", "Sea-Goat"],
    ["11", "कुंभ", "Air", "शनि", "Water-Bearer"],
    ["12", "मीन", "Water", "गुरु", "Fish"],
  ],
} as const;

export const REF_GRAHAS_EN: ReferenceDataset = {
  id: "grahas_en",
  caption: "The 9 grahas — nature, rulership, exaltation & remedial gem",
  columns: ["Graha", "Nature", "Rules", "Exalted in", "Debilitated in", "Gemstone", "Day"],
  rows: [
    ["Sun", "Malefic", "Leo", "Aries", "Libra", "Ruby", "Sunday"],
    ["Moon", "Benefic", "Cancer", "Taurus", "Scorpio", "Pearl", "Monday"],
    ["Mars", "Malefic", "Aries, Scorpio", "Capricorn", "Cancer", "Red Coral", "Tuesday"],
    ["Mercury", "Neutral", "Gemini, Virgo", "Virgo", "Pisces", "Emerald", "Wednesday"],
    [
      "Jupiter",
      "Benefic",
      "Sagittarius, Pisces",
      "Cancer",
      "Capricorn",
      "Yellow Sapphire",
      "Thursday",
    ],
    ["Venus", "Benefic", "Taurus, Libra", "Pisces", "Virgo", "Diamond", "Friday"],
    ["Saturn", "Malefic", "Capricorn, Aquarius", "Libra", "Aries", "Blue Sapphire", "Saturday"],
    ["Rahu", "Malefic", "", "Taurus", "Scorpio", "Hessonite", "Saturday"],
    ["Ketu", "Malefic", "", "Scorpio", "Taurus", "Cats Eye", "Tuesday"],
  ],
} as const;

export const REF_GRAHAS_GEMSTONE_EN: ReferenceDataset = {
  id: "grahas_gemstone_en",
  caption: "Vedic gemstones (Ratna Shastra) — the gem, metal & wearing day for each graha",
  columns: ["Graha", "Gemstone", "Metal", "Wearing day"],
  rows: [
    ["Sun", "Ruby", "Gold", "Sunday"],
    ["Moon", "Pearl", "Silver", "Monday"],
    ["Mars", "Red Coral", "Copper", "Tuesday"],
    ["Mercury", "Emerald", "Bronze", "Wednesday"],
    ["Jupiter", "Yellow Sapphire", "Gold", "Thursday"],
    ["Venus", "Diamond", "Silver", "Friday"],
    ["Saturn", "Blue Sapphire", "Iron", "Saturday"],
    ["Rahu", "Hessonite", "Lead", "Saturday"],
    ["Ketu", "Cats Eye", "Mixed Metals", "Tuesday"],
  ],
} as const;

export const REF_GRAHAS_KARAKA_EN: ReferenceDataset = {
  id: "grahas_karaka_en",
  caption: "The 9 grahas (Navagraha) — what each signifies and which rashis it rules",
  columns: ["Graha", "Signifies (karaka)", "Rules (rashi)"],
  rows: [
    ["Sun", "Soul, Father, Authority, Government, Health, Vitality, Ego", "Leo"],
    ["Moon", "Mind, Mother, Emotions, Fertility, Public, Travel", "Cancer"],
    ["Mars", "Energy, Courage, Siblings, Land, Surgery, Accidents, Anger", "Aries, Scorpio"],
    ["Mercury", "Intelligence, Communication, Trade, Education, Writing, Skin", "Gemini, Virgo"],
    [
      "Jupiter",
      "Wisdom, Children, Wealth, Dharma, Guru, Expansion, Fortune",
      "Sagittarius, Pisces",
    ],
    ["Venus", "Love, Marriage, Beauty, Art, Luxury, Vehicles, Comfort", "Taurus, Libra"],
    [
      "Saturn",
      "Discipline, Karma, Longevity, Delay, Hardship, Servants, Iron",
      "Capricorn, Aquarius",
    ],
    ["Rahu", "Obsession, Foreign, Unconventional, Illusion, Technology, Poison", "—"],
    ["Ketu", "Moksha, Spirituality, Past Life, Detachment, Occult, Surgery", "—"],
  ],
} as const;

export const REF_NAKSHATRAS_EN: ReferenceDataset = {
  id: "nakshatras_en",
  caption: "The 27 nakshatras — rashi, ruling planet, deity & gana",
  columns: ["#", "Nakshatra", "Rashi", "Lord", "Deity", "Gana", "Symbol"],
  rows: [
    ["1", "Ashwini", "Aries", "Ketu", "Ashwini Kumaras", "Deva", "Horse head"],
    ["2", "Bharani", "Aries", "Venus", "Yama", "Manushya", "Yoni (female organ)"],
    ["3", "Krittika", "Aries", "Sun", "Agni", "Rakshasa", "Razor/flame"],
    ["4", "Rohini", "Taurus", "Moon", "Brahma", "Manushya", "Chariot/ox cart"],
    ["5", "Mrigashira", "Taurus", "Mars", "Soma/Chandra", "Deva", "Deer head"],
    ["6", "Ardra", "Gemini", "Rahu", "Rudra", "Manushya", "Teardrop/diamond"],
    ["7", "Punarvasu", "Gemini", "Jupiter", "Aditi", "Deva", "Bow/quiver"],
    ["8", "Pushya", "Cancer", "Saturn", "Brihaspati", "Deva", "Flower/cow udder"],
    ["9", "Ashlesha", "Cancer", "Mercury", "Naga (serpent)", "Rakshasa", "Coiled serpent"],
    ["10", "Magha", "Leo", "Ketu", "Pitris (ancestors)", "Rakshasa", "Throne/palanquin"],
    ["11", "Purva Phalguni", "Leo", "Venus", "Bhaga", "Manushya", "Front legs of bed"],
    ["12", "Uttara Phalguni", "Leo", "Sun", "Aryaman", "Manushya", "Back legs of bed"],
    ["13", "Hasta", "Virgo", "Moon", "Savitar", "Deva", "Palm/hand"],
    ["14", "Chitra", "Virgo", "Mars", "Vishwakarma", "Rakshasa", "Bright jewel/pearl"],
    ["15", "Swati", "Libra", "Rahu", "Vayu", "Deva", "Coral/young sprout"],
    [
      "16",
      "Vishakha",
      "Libra",
      "Jupiter",
      "Indra-Agni",
      "Rakshasa",
      "Triumphal arch/potter's wheel",
    ],
    ["17", "Anuradha", "Scorpio", "Saturn", "Mitra", "Deva", "Lotus"],
    ["18", "Jyeshtha", "Scorpio", "Mercury", "Indra", "Rakshasa", "Earring/umbrella"],
    ["19", "Moola", "Sagittarius", "Ketu", "Nirrti", "Rakshasa", "Bunch of roots"],
    [
      "20",
      "Purva Ashadha",
      "Sagittarius",
      "Venus",
      "Apas (water)",
      "Manushya",
      "Fan/elephant tusk",
    ],
    [
      "21",
      "Uttara Ashadha",
      "Sagittarius",
      "Sun",
      "Vishvadevas",
      "Manushya",
      "Elephant tusk/planks of bed",
    ],
    ["22", "Shravana", "Capricorn", "Moon", "Vishnu", "Deva", "Three footprints/ear"],
    ["23", "Dhanishta", "Capricorn", "Mars", "Vasus", "Rakshasa", "Drum/flute"],
    ["24", "Shatabhisha", "Aquarius", "Rahu", "Varuna", "Rakshasa", "Empty circle/100 flowers"],
    [
      "25",
      "Purva Bhadrapada",
      "Aquarius",
      "Jupiter",
      "Aja Ekapad",
      "Manushya",
      "Front of funeral cot/sword",
    ],
    [
      "26",
      "Uttara Bhadrapada",
      "Pisces",
      "Saturn",
      "Ahir Budhnya",
      "Manushya",
      "Back of funeral cot/twin",
    ],
    ["27", "Revati", "Pisces", "Mercury", "Pushan", "Deva", "Fish/drum"],
  ],
} as const;

export const REF_NAKSHATRA_PADA_LETTERS_EN: ReferenceDataset = {
  id: "nakshatra_pada_letters_en",
  caption: "Baby-name starting syllable for every nakshatra pada (naamkaran)",
  columns: ["#", "Nakshatra", "Pada 1", "Pada 2", "Pada 3", "Pada 4"],
  rows: [
    ["1", "Ashwini", "Chu", "Che", "Cho", "La"],
    ["2", "Bharani", "Li", "Lu", "Le", "Lo"],
    ["3", "Krittika", "A", "I", "U", "E"],
    ["4", "Rohini", "O", "Va", "Vi", "Vu"],
    ["5", "Mrigashira", "Ve", "Vo", "Ka", "Ki"],
    ["6", "Ardra", "Ku", "Gha", "Nga", "Chha"],
    ["7", "Punarvasu", "Ke", "Ko", "Ha", "Hi"],
    ["8", "Pushya", "Hu", "He", "Ho", "Da"],
    ["9", "Ashlesha", "Di", "Du", "De", "Do"],
    ["10", "Magha", "Ma", "Mi", "Mu", "Me"],
    ["11", "Purva Phalguni", "Mo", "Ta", "Ti", "Tu"],
    ["12", "Uttara Phalguni", "Te", "To", "Pa", "Pi"],
    ["13", "Hasta", "Pu", "Sha", "Na", "Tha"],
    ["14", "Chitra", "Pe", "Po", "Ra", "Ri"],
    ["15", "Swati", "Ru", "Re", "Ro", "Taa"],
    ["16", "Vishakha", "Ti", "Tu", "Te", "To"],
    ["17", "Anuradha", "Na", "Ni", "Nu", "Ne"],
    ["18", "Jyeshtha", "No", "Ya", "Yi", "Yu"],
    ["19", "Moola", "Ye", "Yo", "Bha", "Bhi"],
    ["20", "Purva Ashadha", "Bhu", "Dha", "Pha", "Dha"],
    ["21", "Uttara Ashadha", "Bhe", "Bho", "Ja", "Ji"],
    ["22", "Shravana", "Ju", "Je", "Jo", "Gha"],
    ["23", "Dhanishta", "Ga", "Gi", "Gu", "Ge"],
    ["24", "Shatabhisha", "Go", "Sa", "Si", "Su"],
    ["25", "Purva Bhadrapada", "Se", "So", "Da", "Di"],
    ["26", "Uttara Bhadrapada", "Du", "Tha", "Jha", "Da"],
    ["27", "Revati", "De", "Do", "Cha", "Chi"],
  ],
} as const;

export const REF_NAKSHATRA_PADA_LETTERS_HI: ReferenceDataset = {
  id: "nakshatra_pada_letters_hi",
  caption: "नामकरण — हर नक्षत्र के चारों पदों का प्रारंभिक अक्षर",
  columns: ["#", "नक्षत्र", "पद 1", "पद 2", "पद 3", "पद 4"],
  rows: [
    ["1", "अश्विनी", "चु", "चे", "चो", "ला"],
    ["2", "भरणी", "ली", "लू", "ले", "लो"],
    ["3", "कृत्तिका", "अ", "ई", "उ", "ए"],
    ["4", "रोहिणी", "ओ", "वा", "वी", "वू"],
    ["5", "मृगशिरा", "वे", "वो", "का", "की"],
    ["6", "आर्द्रा", "कू", "घ", "ङ", "छ"],
    ["7", "पुनर्वसु", "के", "को", "हा", "ही"],
    ["8", "पुष्य", "हू", "हे", "हो", "ड"],
    ["9", "आश्लेषा", "डी", "डू", "डे", "डो"],
    ["10", "मघा", "मा", "मी", "मू", "मे"],
    ["11", "पूर्व फाल्गुनी", "मो", "टा", "टी", "टू"],
    ["12", "उत्तर फाल्गुनी", "टे", "टो", "पा", "पी"],
    ["13", "हस्त", "पू", "ष", "ण", "ठ"],
    ["14", "चित्रा", "पे", "पो", "रा", "री"],
    ["15", "स्वाति", "रू", "रे", "रो", "ता"],
    ["16", "विशाखा", "ती", "तू", "ते", "तो"],
    ["17", "अनुराधा", "ना", "नी", "नू", "ने"],
    ["18", "ज्येष्ठा", "नो", "या", "यी", "यू"],
    ["19", "मूल", "ये", "यो", "भा", "भी"],
    ["20", "पूर्वाषाढ़ा", "भू", "ध", "फ", "ढ"],
    ["21", "उत्तराषाढ़ा", "भे", "भो", "जा", "जी"],
    ["22", "श्रवण", "जू", "जे", "जो", "घ"],
    ["23", "धनिष्ठा", "गा", "गी", "गू", "गे"],
    ["24", "शतभिषा", "गो", "सा", "सी", "सू"],
    ["25", "पूर्व भाद्रपद", "से", "सो", "दा", "दी"],
    ["26", "उत्तर भाद्रपद", "दू", "थ", "झ", "ञ"],
    ["27", "रेवती", "दे", "दो", "च", "ची"],
  ],
} as const;

export const REF_VIMSHOTTARI_EN: ReferenceDataset = {
  id: "vimshottari_en",
  caption: "Vimshottari mahadasha — years each graha rules",
  columns: ["Graha", "Mahadasha years"],
  rows: [
    ["Ketu", "7"],
    ["Venus", "20"],
    ["Sun", "6"],
    ["Moon", "10"],
    ["Mars", "7"],
    ["Rahu", "18"],
    ["Jupiter", "16"],
    ["Saturn", "19"],
    ["Mercury", "17"],
    ["Total", "120"],
  ],
} as const;

export const REF_VIMSHOTTARI_HI: ReferenceDataset = {
  id: "vimshottari_hi",
  caption: "विमशोत्तरी महादशा — किस ग्रह की दशा कितने वर्ष",
  columns: ["ग्रह", "महादशा वर्ष"],
  rows: [
    ["केतु", "7"],
    ["शुक्र", "20"],
    ["सूर्य", "6"],
    ["चंद्र", "10"],
    ["मंगल", "7"],
    ["राहु", "18"],
    ["गुरु", "16"],
    ["शनि", "19"],
    ["बुध", "17"],
    ["कुल", "120"],
  ],
} as const;

export const REF_YOGINI_EN: ReferenceDataset = {
  id: "yogini_en",
  caption: "The 8 Yoginis — ruling graha and fixed period",
  columns: ["Yogini", "Ruling graha", "Years"],
  rows: [
    ["Mangala", "Moon", "1"],
    ["Pingala", "Sun", "2"],
    ["Dhanya", "Jupiter", "3"],
    ["Bhramari", "Mars", "4"],
    ["Bhadrika", "Mercury", "5"],
    ["Ulka", "Saturn", "6"],
    ["Siddha", "Venus", "7"],
    ["Sankata", "Rahu", "8"],
    ["Total", "—", "36"],
  ],
} as const;

export const REF_NUMBER_COMPAT_EN: ReferenceDataset = {
  id: "number_compat_en",
  caption: "Number compatibility — which Mulanks harmonise (planetary friendship)",
  columns: ["Number (ruling planet)", "Harmonious with"],
  rows: [
    ["1 (Sun)", "1, 2, 3, 9"],
    ["2 (Moon)", "1, 2, 7, 9"],
    ["3 (Jupiter)", "1, 3, 6, 9"],
    ["4 (Rahu)", "1, 4, 5, 7"],
    ["5 (Mercury)", "1, 4, 5, 6"],
    ["6 (Venus)", "3, 5, 6, 9"],
    ["7 (Ketu)", "2, 4, 7, 9"],
    ["8 (Saturn)", "1, 4, 8"],
    ["9 (Mars)", "1, 2, 3, 6, 9"],
  ],
} as const;

export const REF_CHALDEAN_EN: ReferenceDataset = {
  id: "chaldean_en",
  caption: "Chaldean letter values — the map name numerology uses (no letter maps to 9)",
  columns: ["Value", "Letters"],
  rows: [
    ["1", "A, I, J, Q, Y"],
    ["2", "B, K, R"],
    ["3", "C, G, L, S"],
    ["4", "D, M, T"],
    ["5", "E, H, N, X"],
    ["6", "U, V, W"],
    ["7", "O, Z"],
    ["8", "F, P"],
  ],
} as const;

export const REF_RASHI_COMPAT_EN: ReferenceDataset = {
  id: "rashi_compat_en",
  caption: "Rashi compatibility — traditionally harmonious signs",
  columns: ["Rashi", "Most compatible with"],
  rows: [
    ["Aries", "Leo, Sagittarius, Gemini"],
    ["Taurus", "Virgo, Capricorn, Cancer"],
    ["Gemini", "Libra, Aquarius, Aries"],
    ["Cancer", "Scorpio, Pisces, Taurus"],
    ["Leo", "Aries, Sagittarius, Gemini"],
    ["Virgo", "Taurus, Capricorn, Cancer"],
    ["Libra", "Gemini, Aquarius, Aries"],
    ["Scorpio", "Cancer, Pisces, Virgo"],
    ["Sagittarius", "Aries, Leo, Libra"],
    ["Capricorn", "Taurus, Virgo, Pisces"],
    ["Aquarius", "Gemini, Libra, Sagittarius"],
    ["Pisces", "Cancer, Scorpio, Capricorn"],
  ],
} as const;

export const REF_SHODASHVARGA_EN: ReferenceDataset = {
  id: "shodashvarga_en",
  caption: "Shodashvarga — the 16 divisional charts and what each reveals",
  columns: ["Varga", "Name", "Reveals"],
  rows: [
    ["D1", "Rashi", "Base chart, overall life"],
    ["D2", "Hora", "Wealth"],
    ["D3", "Drekkana", "Siblings, courage"],
    ["D4", "Chaturthamsa", "Property, fortune"],
    ["D5", "Panchamsa", "Spiritual merit"],
    ["D7", "Saptamsa", "Children"],
    ["D9", "Navamsa", "Spouse, dharma, spiritual life (most important after d1)"],
    ["D10", "Dasamsa", "Career, profession"],
    ["D12", "Dwadasamsa", "Parents"],
    ["D16", "Shodasamsa", "Vehicles, comforts, happiness"],
    ["D20", "Vimsamsa", "Spiritual progress"],
    ["D24", "Chaturvimsamsa", "Education, learning"],
    ["D27", "Bhamsa/Nakshatramsa", "Strength, vitality"],
    ["D30", "Trimsamsa", "Evils, misfortune"],
    ["D40", "Khavedamsa", "Auspicious/inauspicious effects"],
    ["D60", "Shashtiamsa", "Past life karma (most subtle)"],
  ],
} as const;

export const REF_GUN_MILAN_KOOTAS_EN: ReferenceDataset = {
  id: "gun_milan_kootas_en",
  caption: "Ashtakoota Gun Milan — the 8 kootas and their maximum points",
  columns: ["Koota", "Max points", "What it checks"],
  rows: [
    ["Varna", "1", "Spiritual compatibility & ego"],
    ["Vashya", "2", "Mutual attraction & control"],
    ["Tara", "3", "Health & wellbeing (birth-star)"],
    ["Yoni", "4", "Physical & instinctual compatibility"],
    ["Graha Maitri", "5", "Mental affinity & friendship (rashi lords)"],
    ["Gana", "6", "Temperament (Deva/Manushya/Rakshasa)"],
    ["Bhakoot", "7", "Emotional bond & family welfare (rashi pair)"],
    ["Nadi", "8", "Health & progeny (voids the match if 0)"],
    ["Total", "36", "Sum of all eight kootas"],
  ],
} as const;

export const REF_GUN_MILAN_BANDS_EN: ReferenceDataset = {
  id: "gun_milan_bands_en",
  caption: "Gun Milan score bands — how the 36-guna total is read",
  columns: ["Guna score", "Verdict"],
  rows: [
    ["0–17", "Not recommended for marriage"],
    ["18–24", "Acceptable match"],
    ["25–32", "Very good match"],
    ["33–36", "Excellent match"],
  ],
} as const;

export const REF_GANA_COMPAT_EN: ReferenceDataset = {
  id: "gana_compat_en",
  caption: "Gana compatibility (Gan koota, 6 points) — temperament match",
  columns: ["Gana", "with Deva", "with Manushya", "with Rakshasa"],
  rows: [
    ["Deva", "6", "5", "1"],
    ["Manushya", "5", "6", "0"],
    ["Rakshasa", "1", "0", "6"],
  ],
} as const;

export const REF_BHAKOOT_EN: ReferenceDataset = {
  id: "bhakoot_en",
  caption: "Bhakoot dosh — rashi-distance pairs that void the 7-point koota",
  columns: ["Rashi distance", "Dosha (name)", "Points"],
  rows: [
    ["2/12", "Dhan–Vyaya (wealth / loss)", "0 of 7"],
    ["5/9", "Rog–Karm (health / karma)", "0 of 7"],
    ["6/8", "Ari–Randhra (conflict / longevity)", "0 of 7"],
  ],
} as const;

export const REF_MANGAL_HOUSES_EN: ReferenceDataset = {
  id: "mangal_houses_en",
  caption: "Mangal Dosha houses — where Mars causes the dosha (checked from Lagna, Moon & Venus)",
  columns: ["House", "What it afflicts in marriage"],
  rows: [
    ["1st (Lagna)", "Self, temperament — aggression into the marriage"],
    ["2nd (Kutumba)", "Family, speech, accumulated wealth"],
    ["4th (Sukha)", "Domestic peace, mother, home harmony"],
    ["7th (Kalatra)", "Spouse & marriage itself — the strongest seat"],
    ["8th (Ayu)", "Longevity of union, in-laws, sudden events"],
    ["12th (Vyaya)", "Bed comforts, expenses, separation"],
  ],
} as const;

export const REF_TITHI_CYCLE_EN: ReferenceDataset = {
  id: "tithi_cycle_en",
  caption: "The 5 tithi groups — every lunar day of both pakshas falls in one",
  columns: ["Group", "Tithi numbers", "Tithi names", "Quality"],
  rows: [
    [
      "Nanda (नंदा)",
      "1, 6, 11",
      "Pratipada / Shashthi / Ekadashi",
      "Joyful — good for starting new work, celebrations, travel",
    ],
    [
      "Bhadra (भद्रा)",
      "2, 7, 12",
      "Dwitiya / Saptami / Dwadashi",
      "Auspicious — favorable for all ceremonies and decisions",
    ],
    [
      "Jaya (जया)",
      "3, 8, 13",
      "Tritiya / Ashtami / Trayodashi",
      "Victorious — ideal for work requiring strength or confrontation",
    ],
    [
      "Rikta (रिक्ता)",
      "4, 9, 14",
      "Chaturthi / Navami / Chaturdashi",
      "Empty — avoid new beginnings; good for deity-specific worship",
    ],
    [
      "Poorna (पूर्णा)",
      "5, 10, 15, 30",
      "Panchami / Dashami / Purnima / Amavasya",
      "Complete — highly auspicious; Purnima is the most powerful",
    ],
  ],
} as const;

export const REF_RAHU_KAAL_WEEKDAY_EN: ReferenceDataset = {
  id: "rahu_kaal_weekday_en",
  caption:
    "Weekday Rahu Kaal, Yamaganda & Gulika windows — classical table for a 06:00–18:00 sun day; exact city timings are 1/8th of your real daylight",
  columns: ["Day", "Rahu Kaal", "Yamaganda", "Gulika Kaal"],
  rows: [
    ["Sunday (रविवार)", "16:30–18:00 (8th part)", "12:00–13:30", "15:00–16:30"],
    ["Monday (सोमवार)", "07:30–09:00 (2nd part)", "10:30–12:00", "13:30–15:00"],
    ["Tuesday (मंगलवार)", "15:00–16:30 (7th part)", "09:00–10:30", "12:00–13:30"],
    ["Wednesday (बुधवार)", "12:00–13:30 (5th part)", "07:30–09:00", "10:30–12:00"],
    ["Thursday (गुरुवार)", "13:30–15:00 (6th part)", "06:00–07:30", "09:00–10:30"],
    ["Friday (शुक्रवार)", "10:30–12:00 (4th part)", "15:00–16:30", "07:30–09:00"],
    ["Saturday (शनिवार)", "09:00–10:30 (3rd part)", "13:30–15:00", "06:00–07:30"],
  ],
} as const;

export const REF_FESTIVAL_CONVENTION_EN: ReferenceDataset = {
  id: "festival_convention_en",
  caption:
    "Why two Panchang sources can print different dates for the same festival — the tithi is identical; the vyapini convention that assigns it to a civil day is not",
  columns: ["Festival", "Tithi basis", "Governing convention", "2026", "2027"],
  rows: [
    [
      "Aja Ekadashi",
      "Bhadrapada · Krishna · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Akshaya Tritiya",
      "Vaisakha · Shukla · Tritiya",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Amalaki Ekadashi",
      "Phalguna · Shukla · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Anant Chaturdashi",
      "Bhadrapada · Shukla · Chaturdashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Apara Ekadashi",
      "Jyeshtha · Krishna · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Ashadha Gupt Navratri Begins",
      "Ashadha · Shukla · Pratipada",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Bhai Dooj",
      "Margashirsha · Shukla · Dwitiya",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Buddha Purnima",
      "Vaisakha · Shukla · Purnima",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Chaitra Navratri Begins",
      "Chaitra · Shukla · Pratipada",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Chhath Puja",
      "Margashirsha · Shukla · Shashthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Dev Diwali",
      "Kartika · Shukla · Purnima",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Devshayani Ekadashi",
      "Ashadha · Shukla · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Devuthani Ekadashi (Prabodhini)",
      "Margashirsha · Shukla · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Dhanteras",
      "Kartika · Krishna · Trayodashi",
      "Dusk (pradosh-vyapini)",
      "Shifts one day",
      "Same day",
    ],
    [
      "Diwali (Deepavali)",
      "Kartika · Krishna · Amavasya",
      "Dusk (pradosh-vyapini)",
      "Shifts one day",
      "Same day",
    ],
    [
      "Durga Ashtami (Maha Ashtami)",
      "Ashvina · Shukla · Ashtami",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Dussehra (Vijayadashami)",
      "Ashvina · Shukla · Dashami",
      "Dusk (pradosh-vyapini)",
      "Shifts one day",
      "Shifts one day",
    ],
    [
      "Ganesh Chaturthi",
      "Bhadrapada · Shukla · Chaturthi",
      "Midday (madhyahna-vyapini)",
      "Shifts one day",
      "Same day",
    ],
    [
      "Guru Purnima",
      "Ashadha · Shukla · Purnima",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Hanuman Jayanti",
      "Chaitra · Shukla · Purnima",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Hariyali Teej",
      "Shravana · Shukla · Tritiya",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Indira Ekadashi",
      "Ashvina · Krishna · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Jaya Ekadashi",
      "Magha · Shukla · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Kamada Ekadashi",
      "Chaitra · Shukla · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Kamika Ekadashi",
      "Shravana · Krishna · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Karwa Chauth",
      "Kartika · Krishna · Chaturthi",
      "Dusk (pradosh-vyapini)",
      "Same day",
      "Shifts one day",
    ],
    [
      "Krishna Janmashtami",
      "Bhadrapada · Krishna · Ashtami",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Magha Gupt Navratri Begins",
      "Magha · Shukla · Pratipada",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Maha Navami",
      "Ashvina · Shukla · Navami",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Mahalaya Amavasya (Sarva Pitru)",
      "Ashvina · Krishna · Amavasya",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Matru Navami (Avidhava Navami)",
      "Ashvina · Krishna · Navami",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Mauni Amavasya",
      "Magha · Krishna · Amavasya",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Mohini Ekadashi",
      "Vaisakha · Shukla · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Nag Panchami",
      "Shravana · Shukla · Panchami",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Narak Chaturdashi (Chhoti Diwali)",
      "Kartika · Krishna · Chaturdashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Nirjala Ekadashi",
      "Jyeshtha · Shukla · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Papankusha Ekadashi",
      "Ashvina · Shukla · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Papmochani Ekadashi",
      "Chaitra · Krishna · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Parsva Ekadashi",
      "Bhadrapada · Shukla · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pitru Paksha Begins",
      "Ashvina · Krishna · Pratipada",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Pausha · Shukla · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Magha · Krishna · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Magha · Shukla · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Phalguna · Krishna · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Phalguna · Shukla · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Chaitra · Krishna · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Chaitra · Shukla · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Vaisakha · Krishna · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Vaisakha · Shukla · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Jyeshtha · Krishna · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Jyeshtha · Shukla · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Ashadha · Krishna · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Ashadha · Shukla · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Shravana · Krishna · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Shravana · Shukla · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Bhadrapada · Krishna · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Bhadrapada · Shukla · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Ashvina · Krishna · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Ashvina · Shukla · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Kartika · Krishna · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Kartika · Shukla · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Pradosh Vrat",
      "Margashirsha · Krishna · Trayodashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Raksha Bandhan",
      "Shravana · Shukla · Purnima",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Ram Navami",
      "Chaitra · Shukla · Navami",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Rama Ekadashi",
      "Kartika · Krishna · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sankashti Chaturthi",
      "Magha · Krishna · Chaturthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sankashti Chaturthi",
      "Phalguna · Krishna · Chaturthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sankashti Chaturthi",
      "Chaitra · Krishna · Chaturthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sankashti Chaturthi",
      "Vaisakha · Krishna · Chaturthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sankashti Chaturthi",
      "Jyeshtha · Krishna · Chaturthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sankashti Chaturthi",
      "Ashadha · Krishna · Chaturthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sankashti Chaturthi",
      "Shravana · Krishna · Chaturthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sankashti Chaturthi",
      "Bhadrapada · Krishna · Chaturthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sankashti Chaturthi",
      "Ashvina · Krishna · Chaturthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sankashti Chaturthi",
      "Kartika · Krishna · Chaturthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sankashti Chaturthi",
      "Margashirsha · Krishna · Chaturthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sankashti Chaturthi",
      "Pausha · Krishna · Chaturthi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Sharad Purnima (Kojagari)",
      "Ashvina · Shukla · Purnima",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Shattila Ekadashi",
      "Magha · Krishna · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Shravana Putrada Ekadashi",
      "Shravana · Shukla · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Ugadi / Gudi Padwa",
      "Chaitra · Shukla · Pratipada",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Utpanna Ekadashi",
      "Margashirsha · Krishna · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Varuthini Ekadashi",
      "Vaisakha · Krishna · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Vasant Panchami",
      "Magha · Shukla · Panchami",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
    [
      "Yogini Ekadashi",
      "Ashadha · Krishna · Ekadashi",
      "Sunrise (sunrise-vyapini)",
      "Same day",
      "Same day",
    ],
  ],
} as const;

export const REF_ENGINE_PARAMETERS_EN: ReferenceDataset = {
  id: "engine_parameters_en",
  caption:
    "Ishvaram's published calculation parameters — the exact settings behind every kundali, panchang, muhurat and matching result",
  columns: ["Parameter", "Setting", "What it means"],
  rows: [
    [
      "Zodiac",
      "Sidereal (nirayana)",
      "Positions are measured against the fixed stars, not the moving equinox.",
    ],
    [
      "Ayanamsa",
      "Lahiri (Chitrapaksha)",
      "The ayanamsa of the Indian government's calendar reform and the de-facto standard of modern Jyotish. It is the only mode the engine sets.",
    ],
    [
      "Ephemeris library",
      "Swiss Ephemeris via pyswisseph 2.10.3.2",
      "Pinned exactly, so a given birth moment reproduces the same positions.",
    ],
    [
      "Ephemeris mode",
      "Built-in analytical (Moshier) — no external ephemeris files",
      "No JPL .se1 data files are bundled, so Swiss Ephemeris uses its built-in analytical theory. We do not claim JPL DE-file accuracy.",
    ],
    [
      "Position flags",
      "SEFLG_SWIEPH | SEFLG_SPEED",
      "Speed is computed alongside longitude so retrograde motion is derived, not assumed.",
    ],
    [
      "Rasi chart houses",
      "Whole Sign",
      "A graha's house is counted from the Lagna's rashi, the Parashari convention used across North Indian Jyotish.",
    ],
    [
      "House cusp longitudes",
      "Placidus",
      "Cusps stay Placidus and are used where a quadrant boundary is required — KP sub-lords and divisional-chart precision — not for rasi house counting.",
    ],
    [
      "Rahu and Ketu",
      "Mean node; Ketu derived at Rahu + 180 degrees",
      "The mean lunar node is used throughout; the true node is not used anywhere.",
    ],
    [
      "Panchang day boundary",
      "Local sunrise",
      "The tithi, nakshatra and yoga of a calendar day are the ones running at sunrise for your own city, not at midnight.",
    ],
    [
      "Panchang sunrise and sunset",
      "Hindu rising convention (disc centre, no refraction)",
      "Used for panchang, Rahu Kaal, Yamaganda, Gulika and choghadiya windows, at 1013.25 mbar and 15 degrees C.",
    ],
    [
      "Festival-date sunrise",
      "Standard apparent rise and set",
      "The tithi resolver behind festival dates uses the standard convention; the published festival dates are calibrated against it rather than the reverse.",
    ],
    [
      "Vimshottari dasha year",
      "365.25 days over a 120-year cycle",
      "The solar-year convention, not the 360-day savana year. Antardasha length is (mahadasha years x antardasha years) / 120.",
    ],
  ],
} as const;

export const REF_DOSHAS_UPAY_EN: ReferenceDataset = {
  id: "doshas_upay_en",
  caption:
    "Doshas — the graha, the houses that trigger it, what it affects and the traditional upay",
  columns: ["Dosha", "Graha", "Trigger houses (from Lagna)", "Affects", "Traditional upay"],
  rows: [
    [
      "Mangal Dosha (Manglik)",
      "Mars",
      "4, 7, 8, 12",
      "Marriage, Relationships, Temperament",
      "Recite Hanuman Chalisa on Tuesdays",
    ],
    [
      "Shani Dosha",
      "Saturn",
      "1, 4, 7, 8, 10",
      "Career, Health, Longevity, Obstacles, Karma",
      "Recite Shani Stotram on Saturdays, donate black items",
    ],
    [
      "Rahu Dosha",
      "Rahu",
      "1, 5, 7, 8, 12",
      "Mental Peace, Clarity, Foreign Matters, Obsessions",
      "Recite Rahu Beej Mantra, donate on Saturdays",
    ],
    [
      "Ketu Dosha",
      "Ketu",
      "1, 4, 5, 7, 9",
      "Spirituality, Detachment, Sudden Events, Moksha",
      "Worship Lord Ganesha to remove Ketu obstacles",
    ],
    [
      "Kaal Sarp Dosha",
      "Rahu-Ketu axis",
      "Whole-chart pattern",
      "Overall Life, Karma, Obstacles, Relationships, Career",
      "Perform Nag Panchami pooja and donate at Nag temple; Offer milk on Shivling every Monday",
    ],
    [
      "Pitra Dosha",
      "Rahu-Ketu axis",
      "Whole-chart pattern",
      "Family, Ancestors, Father, Children, Fortune",
      "Perform tarpan (offerings) during Pitru Paksha",
    ],
  ],
} as const;

export const REF_GRAHA_DRISHTI_EN: ReferenceDataset = {
  id: "graha_drishti_en",
  caption: "Parashari drishti — the houses each graha aspects from its own position",
  columns: ["Graha", "Aspects (from itself)", "Note"],
  rows: [
    ["Sun", "7th", "Full drishti on every listed house, counted from its own house."],
    ["Moon", "7th", "Full drishti on every listed house, counted from its own house."],
    ["Mars", "4th, 7th, 8th", "Full drishti on every listed house, counted from its own house."],
    ["Mercury", "7th", "Full drishti on every listed house, counted from its own house."],
    ["Jupiter", "5th, 7th, 9th", "Full drishti on every listed house, counted from its own house."],
    ["Venus", "7th", "Full drishti on every listed house, counted from its own house."],
    ["Saturn", "3rd, 7th, 10th", "Full drishti on every listed house, counted from its own house."],
    ["Rahu", "5th, 7th, 9th", "Full drishti on every listed house, counted from its own house."],
    ["Ketu", "5th, 7th, 9th", "Full drishti on every listed house, counted from its own house."],
  ],
} as const;

export const REF_BHAVA_CLASSES_EN: ReferenceDataset = {
  id: "bhava_classes_en",
  caption: "The Parashari bhava classes — which houses belong to each group",
  columns: ["Bhava class", "Houses"],
  rows: [
    ["Kendra (angular)", "1, 4, 7, 10"],
    ["Panapara (succedent)", "2, 5, 8, 11"],
    ["Apoklima (cadent)", "3, 6, 9, 12"],
    ["Trikona (trine)", "1, 5, 9"],
    ["Dusthana (difficult)", "6, 8, 12"],
    ["Upachaya (growing)", "3, 6, 10, 11"],
  ],
} as const;

export const REF_BHAVA_LIFE_DOMAINS_EN: ReferenceDataset = {
  id: "bhava_life_domains_en",
  caption: "Which life domains each bhava governs (the consultation's own mapping)",
  columns: ["Bhava", "Life domains"],
  rows: [
    ["1", "Health & Wellness"],
    ["2", "Career & Profession, Wealth & Finance"],
    ["3", "Travel & Foreign Settlement"],
    ["4", "Education & Learning, Family & Children, Legal & Property"],
    [
      "5",
      "Marriage & Relationships, Wealth & Finance, Education & Learning, Family & Children, Spiritual Growth",
    ],
    ["6", "Career & Profession, Health & Wellness, Legal & Property, Protection & Obstacles"],
    ["7", "Marriage & Relationships, Family & Children, Legal & Property"],
    ["8", "Marriage & Relationships, Health & Wellness, Legal & Property, Protection & Obstacles"],
    [
      "9",
      "Wealth & Finance, Education & Learning, Family & Children, Spiritual Growth, Travel & Foreign Settlement",
    ],
    ["10", "Career & Profession, Education & Learning"],
    ["11", "Career & Profession, Wealth & Finance"],
    [
      "12",
      "Marriage & Relationships, Health & Wellness, Spiritual Growth, Travel & Foreign Settlement, Protection & Obstacles",
    ],
  ],
} as const;

export const REF_YEAR_TRANSITS_2026: ReferenceDataset = {
  id: "year_transits_2026",
  caption:
    "Shani and Guru rashi transits during 2026, computed by the Ishvaram engine (dates are day-granular from a once-daily sample).",
  columns: ["Graha", "Rashi", "From"],
  rows: [
    ["Shani", "Meen", "Start of 2026"],
    ["Guru", "Mithun", "Start of 2026"],
    ["Guru", "Kark", "2026-06-02"],
    ["Guru", "Singh", "2026-11-01"],
  ],
} as const;

export const REF_YEAR_TRANSITS_2027: ReferenceDataset = {
  id: "year_transits_2027",
  caption:
    "Shani and Guru rashi transits during 2027, computed by the Ishvaram engine (dates are day-granular from a once-daily sample).",
  columns: ["Graha", "Rashi", "From"],
  rows: [
    ["Shani", "Meen", "Start of 2027"],
    ["Shani", "Mesh", "2027-06-03"],
    ["Shani", "Meen", "2027-10-21"],
    ["Guru", "Singh", "Start of 2027"],
    ["Guru", "Kark", "2027-01-25"],
    ["Guru", "Singh", "2027-06-26"],
    ["Guru", "Kanya", "2027-11-27"],
  ],
} as const;

export const REF_YEAR_TRANSITS_2028: ReferenceDataset = {
  id: "year_transits_2028",
  caption:
    "Shani and Guru rashi transits during 2028, computed by the Ishvaram engine (dates are day-granular from a once-daily sample).",
  columns: ["Graha", "Rashi", "From"],
  rows: [
    ["Shani", "Meen", "Start of 2028"],
    ["Shani", "Mesh", "2028-02-24"],
    ["Guru", "Kanya", "Start of 2028"],
    ["Guru", "Singh", "2028-02-29"],
    ["Guru", "Kanya", "2028-07-25"],
    ["Guru", "Tula", "2028-12-27"],
  ],
} as const;

export const REFERENCE_DATASETS: Record<string, ReferenceDataset> = {
  numbers_en: REF_NUMBERS_EN,
  rashis_en: REF_RASHIS_EN,
  rashis_hi: REF_RASHIS_HI,
  grahas_en: REF_GRAHAS_EN,
  grahas_gemstone_en: REF_GRAHAS_GEMSTONE_EN,
  grahas_karaka_en: REF_GRAHAS_KARAKA_EN,
  nakshatras_en: REF_NAKSHATRAS_EN,
  nakshatra_pada_letters_en: REF_NAKSHATRA_PADA_LETTERS_EN,
  nakshatra_pada_letters_hi: REF_NAKSHATRA_PADA_LETTERS_HI,
  vimshottari_en: REF_VIMSHOTTARI_EN,
  vimshottari_hi: REF_VIMSHOTTARI_HI,
  yogini_en: REF_YOGINI_EN,
  number_compat_en: REF_NUMBER_COMPAT_EN,
  chaldean_en: REF_CHALDEAN_EN,
  rashi_compat_en: REF_RASHI_COMPAT_EN,
  shodashvarga_en: REF_SHODASHVARGA_EN,
  gun_milan_kootas_en: REF_GUN_MILAN_KOOTAS_EN,
  gun_milan_bands_en: REF_GUN_MILAN_BANDS_EN,
  gana_compat_en: REF_GANA_COMPAT_EN,
  bhakoot_en: REF_BHAKOOT_EN,
  mangal_houses_en: REF_MANGAL_HOUSES_EN,
  tithi_cycle_en: REF_TITHI_CYCLE_EN,
  rahu_kaal_weekday_en: REF_RAHU_KAAL_WEEKDAY_EN,
  festival_convention_en: REF_FESTIVAL_CONVENTION_EN,
  engine_parameters_en: REF_ENGINE_PARAMETERS_EN,
  doshas_upay_en: REF_DOSHAS_UPAY_EN,
  graha_drishti_en: REF_GRAHA_DRISHTI_EN,
  bhava_classes_en: REF_BHAVA_CLASSES_EN,
  bhava_life_domains_en: REF_BHAVA_LIFE_DOMAINS_EN,
  year_transits_2026: REF_YEAR_TRANSITS_2026,
  year_transits_2027: REF_YEAR_TRANSITS_2027,
  year_transits_2028: REF_YEAR_TRANSITS_2028,
};
